import { Avatar } from '~/shared/components/Avatar';
import { ProfileInfoItem } from '~/shared/types/UserDropdown';

export function BasicInfo({ profileInfo }: { profileInfo: ProfileInfoItem }) {
  return (
    <div className="flex items-center py-3 px-2.5 gap-4 bg-[#F2DC39] rounded-lg">
      <div className="rounded-full bg-white p-0.5">
        <Avatar size="md" name={profileInfo.name} src={profileInfo.urlImage} />
      </div>
      <div className="flex flex-col">
        <span className="text-sm font-medium capitalize">
          {profileInfo.name}
        </span>
        <span className="text-xs text-gray-700">{profileInfo.zone}</span>
      </div>
    </div>
  );
}
